var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_3332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 5.8335H10.8332V7.50016H14.1665C15.5415 7.50016 16.6665 8.62516 16.6665 10.0002C16.6665 11.3752 15.5415 12.5002 14.1665 12.5002H10.8332V14.1668H14.1665C16.4665 14.1668 18.3332 12.3002 18.3332 10.0002C18.3332 7.70016 16.4665 5.8335 14.1665 5.8335ZM9.1665 12.5002H5.83317C4.45817 12.5002 3.33317 11.3752 3.33317 10.0002C3.33317 8.62516 4.45817 7.50016 5.83317 7.50016H9.1665V5.8335H5.83317C3.53317 5.8335 1.6665 7.70016 1.6665 10.0002C1.6665 12.3002 3.53317 14.1668 5.83317 14.1668H9.1665V12.5002ZM6.6665 9.16683H13.3332V10.8335H6.6665V9.16683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_3332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.31c68d2d78b32459a9459167a87e60fc.svg";
export { ForwardRef as ReactComponent };